var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",class:{
        'sidebar_closing': !_vm.isOpen && !_vm.isSmallWindow,
        'sidebar_small': _vm.isSmallWindow
    }},_vm._l((_vm.sidebarItems),function(item,index){return _c('sidebar-item',{key:index,attrs:{"sidebarItem":item,"isOpen":_vm.isOpen,"isSmallWindow":_vm.isSmallWindow,"tooltipPosition":_vm.tooltipPosition}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }